import {useAuthStore} from "../../app-layout/authStore";
import {useCurrentOfficeStore} from "../../api/CurrentOfficeStore";
import {useMemo} from "react";
import {mapRecordValues} from "../MapUtil";
import {Access, PermissionCheck} from "./Access";

export function useAccess(): Access {
    const user = useAuthStore(state => state.user);
    const currentOfficeId = useCurrentOfficeStore(state => state.officeId);
    return useMemo(
        () => new Access(user, currentOfficeId),
        [user, currentOfficeId],
    );
}

export function usePermission<T extends string>(requiredPermissions: Record<T, PermissionCheck>): Record<T, boolean> {
    const access = useAccess();

    return useMemo(() => {
        return mapRecordValues(
            requiredPermissions,
            permission => access.has(permission),
        );
    }, [requiredPermissions, access]);
}